/* eslint-disable */

import React, { Component } from 'react';
import {
  Button,
  Dropdown,
  Divider,
  Form,
  Grid,
  TextArea,
  Loader
} from 'semantic-ui-react';
import _ from 'lodash';

import { buildCampaign, buildAdSet } from '../PackageBuilder/CampaignBuilder';
import { getAccounts } from '../../services/AccountService';
import { getAccount } from '../../fbApi/Account';
import { creds } from '../../config/FBAdOps';
import { createCollectionAd } from './AdCreator.js';
import { getPages } from '../../fbApi/Page';
import { getCanvas } from '../../fbApi/Canvas';
import './AdBuilder.css';

class AdBuilder extends Component {
  state = {
    token: this.props.getFbToken(),
    adTypes: [{ key: 0, value: 'Collection Ad', text: 'Collection Ad' }],
    pages: [],
    showFields: false,
    accountOptions: null,
    processing: false,
    selectedAccount: '',
    message: '',
    logText: '',
    form: {
      productCatalog: '',
      pageId: '',
      canvasUrl: '',
      productSet: '',
      address: '',
      displayLink: '',
      pixel: '',
      videoUrl: '',
      destinationUrl: '',
      videoId: ''
    }
  };

  componentDidMount() {
    this.props.setSectionTitle('Ad Builder');
    this.props.saveGTMEvent('Ad Builder', 'Ad Builder');
    this.getPages();
  }

  getPages = async () => {
    const pages = await getPages(this.state.token);
    this.setState({ pages: pages[0].data.concat(pages[1].data) });
  };

  onAccountSelect = async (event, data) => {
    const account = _.find(data.options, (option) => {
      return option.value === data.value;
    });
    const accountId = account.value;
    const accountData = await getAccount(accountId, this.state.token);
    const form = this.state.form;

    if (accountData && accountData.adspixels && accountData.adspixels.data[0]) {
      form.pixel = accountData.adspixels.data[0].id;
    } else {
      form.pixel = '';
    }

    this.setState({ selectedAccount: accountId, form });
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        accountOptions
      });
    } catch (error) {
      alert(error);
    }
  };

  onAdTypeSelect = (event, data) => {
    this.getAdAccounts();
    this.setState({ showFields: true });
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  generateCampaign = async () => {
    if (!this.state.selectedAccount) {
      this.setState({ message: 'You must select an account' });
      return;
    }

    if (!this.state.form.pixel) {
      this.setState({ message: 'Pixel has not been setup yet' });
      return;
    }

    this.setState({ processing: true, message: '', logText: '' });

    const page = this.state.pages.find(
      (page) => page.id == this.state.form.pageId
    );

    const campaignData1 = {
      name: '2018_Traffic_Campaign',
      objective: 'LINK_CLICKS',
      spend_cap: '12000',
      accountId: this.state.selectedAccount
    };

    const resultCampaign1 = await buildCampaign(
      campaignData1,
      this.state.token
    );

    if (resultCampaign1.id) {
      this.setState({
        logText:
          this.state.logText +
          'Campaign: ' +
          campaignData1.name +
          ' CREATED' +
          '\n'
      });
    } else {
      this.setState({
        logText:
          this.state.logText +
          'Campaign: ' +
          campaignData1.name +
          ' ERROR: ' +
          resultCampaign1.error.error_user_title +
          resultCampaign1.error.message +
          '\n'
      });
    }

    const campaignId1 = resultCampaign1.id;

    const adSetData = {
      campaignId: campaignId1,
      accountId: this.state.selectedAccount,
      name: '2018_Traffic_AdSet',
      end_time: '2018-07-31T23:00:00-0400',
      lifetime_budget: '4000',
      status: 'ACTIVE',
      optimization_goal: 'LINK_CLICKS',
      targetingsentencelines: {
        id: '/targetingsentencelines',
        targetingsentencelines: [
          {
            content: 'Location:',
            children: ['United States: ' + this.state.form.address]
          },
          {
            content: 'Age:',
            children: ['35 - 65+']
          },
          {
            content: 'Gender:',
            children: ['Female']
          }
        ]
      },
      targeting: {
        age_max: 65,
        age_min: 35,
        genders: [2],
        geo_locations: {
          custom_locations: [
            {
              name: this.state.form.address,
              address_string: this.state.form.address,
              radius: 20,
              distance_unit: 'mile'
            }
          ],
          location_types: ['home', 'recent']
        },
        flexible_spec: [
          {
            user_adclusters: [
              {
                id: '6006142989025',
                name:
                  'Automotive powered by Polk > New vehicle shoppers > Economy Car > Compact Car > In Market'
              },
              {
                id: '6056317023425',
                name:
                  'Automotive powered by Polk > New vehicle shoppers > Luxury Compact Car > In Market'
              },
              {
                id: '6056317025625',
                name:
                  'Automotive powered by Polk > New vehicle shoppers > Sub-compact Car > In Market'
              }
            ]
          },
          {
            income: [
              { id: '23842569735510111', name: '3. $75,000 - $99,999' },
              { id: '23842569735560111', name: '4. $100,000 - $124,999' },
              { id: '23842569735600111', name: '5. $125,000 - $149,999' },
              { id: '23842569735640111', name: '6. $150,000 - $249,999' },
              { id: '23842569735690111', name: '7. $250,000 - $349,999' }
            ]
          }
        ],
        publisher_platforms: ['facebook', 'instagram'],
        facebook_positions: ['feed', 'right_hand_column', 'instant_article'],
        instagram_positions: ['stream'],
        device_platforms: ['mobile', 'desktop']
      }
    };

    const resultAdSet1 = await buildAdSet(adSetData, this.state.token);

    if (resultAdSet1.id) {
      this.setState({
        logText:
          this.state.logText + 'AdSet: ' + adSetData.name + ' CREATED' + '\n'
      });
    } else {
      this.setState({
        logText:
          this.state.logText +
          'AdSet: ' +
          adSetData.name +
          ' ERROR: ' +
          resultAdSet1.error.error_user_title +
          resultAdSet1.error.message +
          '\n'
      });
    }

    const parameters = {
      adSetId: resultAdSet1.id,
      accountId: this.state.selectedAccount,
      name: '2018_Traffic_Ad',
      status: 'ACTIVE',
      productSet: this.state.form.productSet,
      pageId: this.state.form.pageId,
      videoId: null,
      title: 'Explore Our Beetle Inventory',
      message:
        'Add a splash of style to your life with the fun-to-drive Beetle. With great deals, now is the perfect time to get behind the wheel.',
      displayLink: this.state.form.displayLink,
      canvasUrl: this.state.form.canvasUrl,
      imageUrl:
        'https://s3.amazonaws.com/alexia-ad-builder-dev/Volkswagen/2_COL_180605_VW_thumbnail_beetle.png',
      urlTags:
        'sd_campaign=BEETLE_NER&sd_digadprov=Constellation&sd_channel=Social&sd_campaign_type=Facebook&utm_source=Facebook&utm_campaign=Constellation&utm_content=Beetle-LangEN&utm_medium=Collection-{{site_source_name}}-{{placement}}&utm_term={{ad.name}}',
      pixel: this.state.form.pixel,
      token: this.state.token,
      pageToken: page.access_token,
      videoUrl: this.state.form.videoUrl,
      destinationUrl: this.state.form.destinationUrl,
      buttonText: 'Tap to Explore Inventory'
    };

    const resultAd = await createCollectionAd(parameters);

    if (resultAd.id) {
      this.setState({
        logText:
          this.state.logText + 'Ad: ' + parameters.name + ' CREATED' + '\n'
      });
    } else {
      this.setState({
        logText:
          this.state.logText +
          'Ad: ' +
          parameters.name +
          ' ERROR: ' +
          resultAd.error.error_user_title +
          resultAd.error.message +
          '\n'
      });
    }

    this.setState({ processing: false });
  };

  render() {
    return (
      <div className="form-container">
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column>
              <Dropdown
                placeholder="Select Ad Type"
                search
                selection
                options={this.state.adTypes}
                onChange={this.onAdTypeSelect}
              />
            </Grid.Column>
            <Grid.Column>
              {this.state.showFields ? (
                <div>
                  <div className="form-field">
                    <label className="label-name">Page ID:</label>
                    <Form.Input
                      className="input-form"
                      placeholder="Enter Page Id"
                      type="text"
                      name="pageId"
                      value={this.state.form.pageId}
                      onChange={this.handleFormChange}
                    />
                  </div>
                  <div className="form-field">
                    <label className="label-name">Video URL:</label>
                    <Form.Input
                      className="input-form"
                      placeholder="Enter Video Url"
                      type="text"
                      name="videoUrl"
                      value={this.state.form.videoUrl}
                      onChange={this.handleFormChange}
                    />
                  </div>
                  <div className="form-field">
                    <label className="label-name">Product Catalog:</label>
                    <Form.Input
                      className="input-form"
                      placeholder="Enter Product Catalog"
                      type="text"
                      name="productCatalog"
                      value={this.state.form.productCatalog}
                      onChange={this.handleFormChange}
                    />
                  </div>
                  <div className="form-field">
                    <label className="label-name">Product Set:</label>
                    <Form.Input
                      className="input-form"
                      placeholder="Enter Product Set"
                      type="text"
                      name="productSet"
                      value={this.state.form.productSet}
                      onChange={this.handleFormChange}
                    />
                  </div>
                  <div className="form-field">
                    <label className="label-name">Destination URL:</label>
                    <Form.Input
                      className="input-form"
                      placeholder="Enter Destination Url"
                      type="text"
                      name="destinationUrl"
                      value={this.state.form.destinationUrl}
                      onChange={this.handleFormChange}
                    />
                  </div>
                  <div className="form-field">
                    <label className="label-name">Address:</label>
                    <Form.Input
                      className="input-form"
                      placeholder="Enter Address"
                      type="text"
                      name="address"
                      value={this.state.form.address}
                      onChange={this.handleFormChange}
                    />
                  </div>
                  <div className="form-field">
                    <label className="label-name">Canvas URL:</label>
                    <Form.Input
                      className="input-form"
                      type="text"
                      name="canvasUrl"
                      disabled
                      value={this.state.form.canvasUrl}
                      onChange={this.handleFormChange}
                    />
                  </div>
                  <div className="form-field">
                    <label className="label-name">Pixel:</label>
                    <Form.Input
                      className="input-form"
                      type="text"
                      name="pixel"
                      disabled
                      value={this.state.form.pixel}
                      onChange={this.handleFormChange}
                    />
                  </div>
                  <div className="form-field">
                    <label className="label-name">Display Link:</label>
                    <Form.Input
                      className="input-form"
                      placeholder="Enter Display Link"
                      type="text"
                      name="displayLink"
                      value={this.state.form.displayLink}
                      onChange={this.handleFormChange}
                    />
                  </div>
                </div>
              ) : null}
            </Grid.Column>
            <Grid.Column>
              {this.state.showFields ? (
                <div>
                  <Dropdown
                    className="field-accounts"
                    placeholder="Ad Accounts"
                    search
                    selection
                    options={this.state.accountOptions}
                    onChange={this.onAccountSelect}
                  />
                  <Button
                    className="floated left tiny grey"
                    onClick={() => this.generateCampaign()}
                  >
                    Launch
                  </Button>
                </div>
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        {this.state.message ? (
          <div>
            <span>{this.state.message}</span>
          </div>
        ) : null}
        {this.state.processing ? (
          <div className="processing-container">
            <span>
              {' '}
              <Loader inline className="active" /> Processing...{' '}
            </span>
          </div>
        ) : null}
        <Divider hidden />
        {this.state.showFields ? (
          <TextArea
            className="debug-log"
            placeholder="Debug Log"
            disabled
            rows="18"
            value={this.state.logText}
          />
        ) : null}
      </div>
    );
  }
}

export default AdBuilder;



// WEBPACK FOOTER //
// ./src/screens/AdBuilder/AdBuilder.js